import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  get: async (id) => {
    return request(`${API_URL}/contractors/suppliers/${id}`, 'get', {}, {});
  },

  getAvailableSupppliers: async (warehouseOwnerId) => {
    return request(`${API_URL}/contractors/suppliers/get-available-suppliers/${warehouseOwnerId}`, 'post', {}, {});
  },

  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/contractors/suppliers/${id}`, 'put', body, {});
  },

  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/contractors/suppliers/`, 'post', body, {});
  },

  delete: async (id) => {
    return request(`${API_URL}/contractors/suppliers/${id}`, 'delete', {}, {});
  },
};
